import { ApiUrl } from "../../../assets/data/TkApiUrlProperty";
import http from "../../../services/http";
import {
  IAPI_CON001_Request,
  IAPI_CON001_Response,
  IAPI_RET019_Request,
  IAPI_RET019_Response,
} from "../../../type/apiType";

// 契約者一覧参照
const httpAPI_CON001 = async (
  param: IAPI_CON001_Request
): Promise<IAPI_CON001_Response> => {
  let res = await http.post(ApiUrl.API_CON001, {
    ...param,
  });

  return res.data;
};

// 退職者検索
const httpAPI_RET019 = async (
  param: IAPI_RET019_Request
): Promise<IAPI_RET019_Response> => {
  let res = await http.post(ApiUrl.API_RET019, {
    ...param,
  });

  return res.data;
};

export { httpAPI_CON001, httpAPI_RET019 };
